export class WarrantyCheckRequest {
    firstRegisteredOrManufacturedDate: Date;
    quoteStateId: number;
    manufacturer: string;
    vehicleMileage: number;
}
